import React from 'react'
import { Card, Input, Space, Button } from 'antd'
import { SearchOutlined, DownloadOutlined } from '@ant-design/icons'
import { useSettlements } from '../hooks/useSettlements'
import { useSettlementActions } from '../hooks/useSettlementActions'
import { useExport } from '../../../shared/hooks/useExport'
import { SettlementsTable } from '../components/SettlementsTable'
import { SettlementDetailsDrawer } from '../components/SettlementDetailsDrawer'

export const SettlementsScreen: React.FC = () => {
    const { settlements, searchText, setSearchText } = useSettlements()
    const { exportToCSV } = useExport()
    const {
        selectedSettlement,
        isDetailDrawerOpen,
        handleViewDetails,
        handleProcessSettlement,
        closeDrawer
    } = useSettlementActions()

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <Card>
                <Space style={{ marginBottom: 16 }}>
                    <Input
                        placeholder="Search settlements..."
                        prefix={<SearchOutlined />}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{ width: 300 }}
                    />
                    <Button icon={<DownloadOutlined />} onClick={() => exportToCSV(settlements, 'settlements-export')}>
                        Export
                    </Button>
                </Space>

                <SettlementsTable
                    settlements={settlements}
                    onRowClick={handleViewDetails}
                    onProcessClick={handleProcessSettlement}
                />
            </Card>

            <SettlementDetailsDrawer
                settlement={selectedSettlement}
                open={isDetailDrawerOpen}
                onClose={closeDrawer}
                onProcess={handleProcessSettlement}
            />
        </Space>
    )
}
